import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function FaqSection({ content }) {
  return (
    <section id="faq" className="bg-fade-blue-up py-24" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <SectionHeading
          number="10"
          eyebrow="FAQ"
          title="Pertanyaan Seputar Perumahan Type 36 Pontianak"
          align="center"
        />
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {content.faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left font-display text-base font-bold text-brand-dark hover:text-brand hover:no-underline sm:text-lg">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
